window.NPS = window.NPS || {};
window.NPS.Views = window.NPS.Views || {};
window.NPS.Views.Browser = window.NPS.Views.Browser || {};

window.NPS.Views.Browser.create = (function($, _) {
	var _super = NPS.Views.Editor;

    function editor(el, opts) {
        opts.path = opts.root + '/edition/editors/browser/';
        _super.call(this, el, opts);
    }
    editor.prototype = Object.create(_super.prototype);
    editor.prototype.constructor = editor;


    editor.prototype.load = function (page, data, done) {
        var self = this;
        return _super.prototype.load.call(this, page, data, done).then(function(r) {
            self.stage();
            return r;
        });
    };


    editor.prototype.stage = function () {
        var self = this;

        self.$el.on('click.workbenchChoose', '[data-folder]', function() {
            var $folder = $(this);

            self.$el.find('[data-folder]').removeClass('elected');
            $folder.addClass('elected');

            self.folder = $folder.data('folder');
            self.query = null;
            self.update({
                folder: self.folder
            });
        });
        self.$el.on('click.workbenchChoose', '[data-page]', function(e) {
            var $page = $(this);

            self.update({
                folder: self.folder || null,
                query: self.query || null,
                page: $page.data('page')
            });

            e.preventDefault();
        });
        self.$el.on('submit.workbenchChoose', '#searchZone', function(e) {
            var query = $(this).find('input').val();

            self.query = query;
            self.update({
                folder: self.folder || null,
                query: query
            });

            e.preventDefault();
        });

        self.$el.on('click.workbenchChoose', '.element', function() {
            var $item = $(this);

            if (!self.chosenOne().is($item)) {
                self.mark($item.data('key'));
            } else {
                self.unmark();
            }
        });

        self.register('choose', 'next', function() {
            var done = self.opts.done, $chosen = self.chosenOne().get();
            if (done) {
                done({
                    key: $chosen.data('key'),
                    name: $chosen.text(),
                });
            }
        });

        return self;
    };
    editor.prototype.unstage = function () {
        var self = this;

        self.unregister('choose');
        self.$el.off('.workbenchChoose');

        return self;
    };


    editor.prototype.update = function (data) {
        var self = this;
        data = _.extend({browser: this.opts.browser}, this.data, data);

        self.unmark();
        $.post(this.url('results.htm'), data).then(function(resp) {
            self.$el.find('[data-role="results"]').html(resp);
        });

        return self;
    };

    editor.prototype.mark = function (id) {
        var self = this,
            $results = self.$el.find('[data-role="results"]'),
            $item = $results.find('[data-key="'+id+'"]');

        self.chosenOne().set($item);
        self.enable('next');

        return self;
    };
    editor.prototype.unmark = function () {
        var self = this;

        self.chosenOne().set(null);
        self.disable('next');

        return self;
    };

    editor.prototype.chosenOne = function () {
        var self = this;
        var get = function() {
            return self.$el.find('[data-role="results"]').find('.chosenOne');
        };
        var set = function($item) {
            get().removeClass('chosenOne');
            if ($item) {
                $item.addClass('chosenOne');
            }
            return self;
        };
        var is = function($item) {
            return get().is($item);
        };
        var has = function() {
            return !!get().length;
        };
        return {
            get: get,
            is: is,
            has: has,
            set: set
        };
    };



    return function(el, opts) {
        return new editor(el, opts);
    };

})(window.jQuery, window._);

